import { createContext, useRef } from "react";

export const ScrollContext = createContext(null);
export const ScrollContextProvider = ({ children }) => {
  const changeLocation = (pos) => {
    // console.log(pos.current);
    pos.current.scrollIntoView(pos);
  };
  const HomeRef = useRef(null);
  const AboutRef = useRef(null);
  const ProjectRef = useRef(null);
  const ContactRef = useRef(null);
  const SingleProjectRef = useRef(null);

  return (
    <ScrollContext.Provider
      value={{
        HomeRef,
        AboutRef,
        ProjectRef,
        ContactRef,
        SingleProjectRef,
        changeLocation,
      }}
    >
      {children}
    </ScrollContext.Provider>
  );
};
